import { useScreen } from "../context/ScreenContext";
import { ChoiceToggle, DateInput, LabelInput } from "./Inputs";

const KidForm = ({ handleChange, maxDate, minDate }) => {

    const {isSmallScreen} = useScreen()

    return ( 
        <div
            style={{
                borderRadius: "4px",
                boxShadow: "1px 2px 2px gray, -1px 2px 2px gray",
                margin: 5,
                padding: 5,
                width: "90%",
                display: "flex",
                flexDirection: isSmallScreen ? "row" : "column",
                flexWrap: isSmallScreen ? "wrap" : "wrap",
                justifyContent: isSmallScreen ? "space-between" : "center",
                gap: "1rem",
            }}
            >
            <LabelInput
                label={"Nom"}
                name={"surname"}
                onChange={handleChange}
                placeholder={""}
                type={"text"}
                required={true}
            />
            <LabelInput
                label={"Prénom"}
                name={"firstname"}
                onChange={handleChange}
                placeholder={""}
                type={"text"}
                required={true}
            />
            <LabelInput
                label={"Commune de résidence et CP"}
                name={"adress"}
                onChange={handleChange}
                placeholder={"Commune de résidence et code postal"}
                type={"text"}
            />
            <LabelInput
                label={"Email du responsable"}
                name={"email"}
                onChange={handleChange}
                placeholder={"Email"}
                type={"email"}
                required={true}
            />
            <LabelInput
                label={"Téléphone du responsable"}
                name={"telephone"}
                onChange={handleChange}
                placeholder={"Téléphone"}
                type={"tel"}
                required={true}
            />
            <div
                style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "center",
                gap: "1rem",
                width: "100%",
                }}
            >
                <DateInput
                    handleChange={handleChange}
                    label={"Date de naissance"}
                    name={"birthDate"}
                    minDate={minDate}
                    maxDate={maxDate}
                />
                <ChoiceToggle
                    label={"Sexe"}
                    option1={"F"}
                    option2={"H"}
                    onChange={handleChange}
                    name={"sex"}
                />
            </div>
        </div>
     );
}
 
export default KidForm;